import { FeatureT } from 'types/shared/core/Feature';

export const Feature = {
  featureNames: new Map<FeatureT, string>([
    ['adFree', '광고 제거'],
    ['homework', '숙제 기능'],
    ['homeworkComment', '숙제 댓글'],
    ['homeworkCommentUpload', '숙제 댓글 파일 업로드'],
    ['attendanceRealtime', '실시간 출결'],
    ['postReview', '글 검토'],
    ['managementAddon', '학원 관리 확장'],
    ['commsAddon', '소통 확장'],
    ['comsPostViewer', '글 뷰어'],
    ['comsPcChat', 'PC 상담톡'],
    ['chatSubscription', '채팅방 알림 구독'],
    ['simpleExam', '시험 점수 관리'],
    ['lessonReport', '수업 리포트'],
    ['exam', '시험 기능'],
    ['analysisReport', '성적 분석 리포트'],
  ]),
  featureIntroSlugs: new Map<FeatureT, string>([
    ['adFree', 'notice-advertisement'],
    ['homework', 'notice-homework'],
    ['homeworkComment', 'notice-homework'],
    ['homeworkCommentUpload', 'notice-homework'],
    ['attendanceRealtime', 'notice-schedule-management-system'],
    ['postReview', 'notice-post-review'],
    ['managementAddon', ''],
    ['commsAddon', ''],
    ['comsPostViewer', ''],
    ['comsPcChat', 'pc-chat-app-early-supporter-rewards'],
    ['chatSubscription', ''],
    ['simpleExam', ''],
    ['lessonReport', ''],
    ['exam', ''],
    ['analysisReport', ''],
  ]),
};
